var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotLocationSelector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.654,
    height: 39.375,
    viewBox: "0 0 46.654 39.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.654,
    height: 38.375,
    rx: 4,
    fill: "none",
    stroke: "#b6b6b6",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.912-384c-.008.5-.017.99-.023,1.485,0,.279,0,.558,0,.81,5.036.892,7.9,3.9,8.878,8.876h2.271v2.265h-2.291c-.1.518-.172,1.017-.305,1.5a9.793,9.793,0,0,1-4.168,5.723,10.118,10.118,0,0,1-4.18,1.572c-.17.025-.209.084-.207.239.006.617,0,1.233,0,1.849v.268h-2.235c0-.086-.011-.17-.011-.254,0-.625,0-1.249,0-1.874,0-.145-.034-.2-.195-.225a9.559,9.559,0,0,1-5.322-2.423,10.094,10.094,0,0,1-3.182-5.563c-.055-.257-.092-.519-.141-.8h-2.341v-2.258h2.291c.886-5.092,3.836-8.022,8.9-8.9V-384Zm-1.135,20.13a7.809,7.809,0,0,0,7.812-7.809,7.807,7.807,0,0,0-7.828-7.841,7.8,7.8,0,0,0-7.82,7.844A7.8,7.8,0,0,0,274.777-363.87Z",
    transform: "translate(-252.465 391.002)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.966-252.984a4.474,4.474,0,0,1-4.456-4.534,4.48,4.48,0,0,1,4.507-4.411,4.473,4.473,0,0,1,4.429,4.487A4.472,4.472,0,0,1,388.966-252.984Z",
    transform: "translate(-366.682 276.764)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotLocationSelector);
export default __webpack_public_path__ + "static/media/iotLocationSelector.1938e9cf33d663bf78eeb4cecdef622b.svg";
export { ForwardRef as ReactComponent };